import {
  KYDInternalCampaign,
  KYDEventBlockData,
} from "@common/interfaces/KYDCampaign";
import placeholder from "../Overview/placeholder.png";

export const findImageForCampaign = (campaign: KYDInternalCampaign): string => {
  if (!campaign || !campaign.blocks?.length) {
    return placeholder;
  }

  const block = campaign.blocks?.find(
    (b) =>
      b.type === "eventList" ||
      b.type === "event2col" ||
      b.type === "event1col" ||
      b.type === "image" ||
      b.type === "image2col"
  );

  if (!block) {
    return placeholder;
  }

  if (typeof block === "object" && "events" in block) {
    const event = block.events[0] as KYDEventBlockData;
    // @ts-ignore
    return event?.custom_image || event?.event?.image || placeholder;
  }

  if (typeof block === "object" && "event" in block) {
    // @ts-ignore
    return block.event?.image || block.event?.event?.image || placeholder;
  }

  if (typeof block === "object" && "src" in block) {
    return block.src;
  }

  if (typeof block === "object" && "images" in block) {
    return block.images?.[0]?.src || placeholder;
  }

  return placeholder;
};
